import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b541981"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Force Update Edit ")
  ])
], -1))
const _hoisted_4 = { class: "col-6 text-start" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Customer" }, "Customer", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Rider" }, "Rider", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "App type", -1))
const _hoisted_10 = { class: "form-floating" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Android" }, "Android", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Apple" }, "Apple", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Device type", -1))
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Version Code", -1))
const _hoisted_17 = { class: "form-floating" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Version Name", -1))
const _hoisted_19 = { class: "form-check" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Is Force Update ", -1))
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " is DB Schema Change ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.app_type) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_8, 512), [
              [_vModelSelect, $setup.data.app_type]
            ]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.device_type) = $event)),
              class: "form-control",
              required: ""
            }, _hoisted_13, 512), [
              [_vModelSelect, $setup.data.device_type]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.version_code) = $event)),
              class: "form-control",
              placeholder: "Version code",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.version_code]
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.version_name) = $event)),
              class: "form-control",
              placeholder: "Version Name",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.data.version_name]
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.is_force_update) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_force_update]
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.is_db_schema_change) = $event)),
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault"
            }, null, 512), [
              [_vModelCheckbox, $setup.data.is_db_schema_change]
            ]),
            _hoisted_22
          ]),
          _hoisted_23
        ], 32)
      ])
    ])
  ]))
}